import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { GlobalsService } from '../../services/globals.service';
import { PhotoSideBySideService } from '../../services/photo-side-by-side.service';
export class PhotoSideBySideModalComponent {
    constructor(dialogRef, data, globals, photoSideBySideService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.globals = globals;
        this.photoSideBySideService = photoSideBySideService;
        this.loading = true;
        this.isFileIdPdf = false;
        this.isPhotoIdPdf = false;
        this.userProcessId = data.userProcessId;
    }
    ngOnInit() {
        this.loadPhotos();
    }
    loadPhotos() {
        this.loading = true;
        this.error = null;
        this.photoSideBySideService.getPhotoSideBySide(this.userProcessId)
            .then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (response && response.Success && response.Data) {
                this.photoIdFileName = response.Data.PhotoIdFileName;
                this.fileId = response.Data.FileId;
                // Construir URLs completas para las imágenes/PDFs
                const checkPromises = [];
                if (this.photoIdFileName) {
                    this.photoIdUrl = `${this.globals.sa}/${this.photoIdFileName}`;
                    // Verificar si es PDF por nombre primero
                    this.isPhotoIdPdf = this.isPdfFile(this.photoIdFileName);
                    // Si no se detectó por nombre, verificar por Content-Type
                    if (!this.isPhotoIdPdf) {
                        checkPromises.push(this.checkFileType(this.photoIdUrl, 'photoId'));
                    }
                }
                if (this.fileId) {
                    this.fileIdUrl = `${this.globals.sa}/${this.fileId}`;
                    // Verificar si es PDF por nombre primero
                    this.isFileIdPdf = this.isPdfFile(this.fileId);
                    // Si no se detectó por nombre, verificar por Content-Type
                    if (!this.isFileIdPdf) {
                        checkPromises.push(this.checkFileType(this.fileIdUrl, 'fileId'));
                    }
                }
                // Esperar a que todas las verificaciones de tipo de archivo terminen
                // Usar Promise.all ya que checkFileType maneja los errores internamente
                if (checkPromises.length > 0) {
                    yield Promise.all(checkPromises.map(p => p.catch(() => { })));
                }
                this.loading = false;
            }
            else {
                this.error = 'No se encontraron archivos disponibles';
                this.loading = false;
            }
        }))
            .catch((error) => {
            this.error = 'Error al cargar los archivos';
            this.loading = false;
            console.error('Error loading files:', error);
        });
    }
    isPdfFile(fileName) {
        if (!fileName)
            return false;
        return fileName.toLowerCase().endsWith('.pdf');
    }
    checkFileType(url, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Hacer una petición HEAD para verificar el Content-Type sin descargar el archivo completo
                const response = yield fetch(url, { method: 'HEAD' });
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.toLowerCase().includes('application/pdf')) {
                    if (type === 'photoId') {
                        this.isPhotoIdPdf = true;
                    }
                    else {
                        this.isFileIdPdf = true;
                    }
                }
            }
            catch (error) {
                console.warn(`No se pudo verificar el tipo de archivo para ${type}:`, error);
                // Si falla la verificación, intentar cargar como imagen
                // El error se manejará en onImageError si no es una imagen válida
            }
        });
    }
    close() {
        this.dialogRef.close();
    }
    onImageError(imageType) {
        // Si la imagen falla al cargar, verificar si podría ser un PDF
        const url = imageType === 'photoId' ? this.photoIdUrl : this.fileIdUrl;
        if (url) {
            // Verificar si es PDF cuando la imagen falla
            this.checkFileType(url, imageType).then(() => {
                // Si se detectó como PDF, el flag ya se actualizó en checkFileType
                // Si no es PDF, entonces realmente no hay archivo disponible
                if (imageType === 'photoId' && !this.isPhotoIdPdf) {
                    this.photoIdUrl = null;
                }
                else if (imageType === 'fileId' && !this.isFileIdPdf) {
                    this.fileIdUrl = null;
                }
            });
        }
        else {
            if (imageType === 'photoId') {
                this.photoIdUrl = null;
            }
            else {
                this.fileIdUrl = null;
            }
        }
    }
}
